import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UbicacionService {

  private baseApiUrl = environment.baseApi + '/publico/ubicacion';
    
  constructor(private httpClient: HttpClient) { }

  async obtenerEstados(): Promise<any> {
    return await this.httpClient.get<any>(`${this.baseApiUrl}/estados`).toPromise();
  }

  async obtenerCiudadesPorEstado(idEstado: number): Promise<any> {
    return await this.httpClient.get<any>(`${this.baseApiUrl}/ciudades/${idEstado}`).toPromise();
  }

  async obtenerPaises(): Promise<any> {
    return await this.httpClient.get<any>(`${this.baseApiUrl}/paises`).toPromise();
  }
}
